import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

type TStyles = {
  stepNavigator: (theme: Theme) => SystemStyleObject<Theme>;
  stepper: (theme: Theme) => SystemStyleObject<Theme>;
  step: (theme: Theme) => SystemStyleObject<Theme>;
  stepLabel: (theme: Theme) => SystemStyleObject<Theme>;
  stepIcon: (theme: Theme) => SystemStyleObject<Theme>;
};

export const styles: TStyles = {
  stepNavigator: (theme: Theme) => ({
    margin: theme.spacing(2.5, '10%', 1.25, '10%'),
    padding: theme.spacing(2.5, 2.5, 0, 2.5),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(2, 1, 1, 1),
      padding: theme.spacing(2, 1, 0, 1),
    },
  }),

  stepper: (theme: Theme) => ({
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  }),

  step: (theme: Theme) => ({
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingLeft: 0,
      paddingRight: 0,
    },
  }),

  stepLabel: (theme: Theme) => ({
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      textAlign: 'left',
      '& .MuiStepLabel-labelContainer': {
        marginLeft: theme.spacing(2),
      },
    },
  }),

  stepIcon: (theme: Theme) => ({
    width: 30,
    height: 30,
    fontSize: '1.2rem',
    [theme.breakpoints.down('sm')]: {
      width: 25,
      height: 25,
      fontSize: '0.9rem',
    },
  }),
};
